import { useState } from 'react';

import { useDebounceSearchSetState } from '@components/Filter/hooks/useDebounceSearchSet';

type UseDebounceTextSearchReturnValue = [
  string,
  string,
  (value: string) => void,
];

export const useDebounceTextSearch = (): UseDebounceTextSearchReturnValue => {
  const [textSearchAsFilterValue, setTextSearch] = useState<string>('');
  const [textSearchAsSearchValue, onTextSearchChange] =
    useDebounceSearchSetState(setTextSearch);

  return [textSearchAsFilterValue, textSearchAsSearchValue, onTextSearchChange];
};
